import { pick } from 'lodash'
import { forwardRef, useState } from 'react'
import { useEffect } from 'react'
import { SmallButton } from '../Buttons/SmallButton'
import { useRouter } from 'next/router'
import { isCYOProduct } from '../../helpers/slug'

const getMaxLength = (router) => {
    if (router.asPath.includes('real-penned')) {
        if (router.asPath.includes('real-penned-letters')) {
            return 300
        }

        return router.asPath.includes('postcard') ? 265 : 10000
    }

    if (isCYOProduct({ slug: router.asPath })) {
        return 300
    }

    return 10000
}

export const Textarea = forwardRef(({ item, ...props }, ref) => {
    let { label, setValue, ...left } = props

    const router = useRouter()

    // let { maxLength = 10000 } = props

    let maxLength = getMaxLength(router)

    const [value, setLocalValue] = useState(item.defaultValue || '')

    if (!item?.required) {
        item.required = false
    }

    left = pick(left, ['cols', 'rows', 'placeholder', 'name', 'id'])

    const handleSetValue = (value) => {
        setLocalValue(value)
        setValue(item.name, value)
    }

    useEffect(() => {
        setValue(item.name, value)
    }, [])

    return (
        <div className="space-y-2 my-2">
            <label
                htmlFor="about"
                className="block text-sm font-medium text-olm-black sm:mt-px sm:pt-2">
                {label || item.name}
                {item.required && <span className="text-red-500">*</span>}
                {item.helper !== '' && (
                    <p className="mt-1 text-sm text-gray-500 font-normal">
                        {item.helper}
                    </p>
                )}
            </label>
            <div className="sm:mt-0 sm:col-span-2" key={item.defaultValue}>
                <textarea
                    data-input-name={item.name}
                    maxLength={maxLength}
                    ref={ref}
                    rows={item?.rows || 2}
                    onChange={(e) => handleSetValue(e.target.value)}
                    value={value}
                    {...left}
                    className="shadow-sm block w-full focus:ring-olm focus:border-olh sm:text-sm border border-gray-300 rounded-md"
                />

                {maxLength != 10000 && (
                    <p className="mt-2 text-sm text-gray-500">
                        {maxLength} character limit, including spaces{' '}
                    </p>
                )}

                {item?.has_multiple_default_values && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                        {item?.multiple_default_values.map(
                            ({ name, value }, index) => (
                                <SmallButton
                                    data-button-id={value}
                                    key={index}
                                    type="button"
                                    className="text-center flex justify-center"
                                    onClick={() => {
                                        handleSetValue(value)
                                    }}>
                                    {name}
                                </SmallButton>
                            ),
                        )}
                    </div>
                )}
            </div>
        </div>
    )
})

Textarea.displayName = 'Textarea'
